import React from 'react'
import DistributorContainer from './DistributorContainer'

const Distributor = () => <DistributorContainer data-test="component-tradeIn-distributor" />

export default Distributor
